
import React from "react";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuCheckboxItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

interface TaskDependencySelectorProps {
  selectedDependencies: string[];
  availableTasks: {id: string, name: string}[];
  handleDependencyChange: (taskId: string) => void;
  isRestrictedUser?: boolean;
}

export const TaskDependencySelector: React.FC<TaskDependencySelectorProps> = ({
  selectedDependencies,
  availableTasks,
  handleDependencyChange,
  isRestrictedUser = false
}) => {
  return (
    <div className="grid grid-cols-1 gap-2">
      <Label htmlFor="dependencies" className="text-black">Dependencies</Label>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="outline"
            disabled={isRestrictedUser}
            className={`w-full justify-between text-left font-normal ${
              isRestrictedUser 
                ? "bg-gray-100 border-gray-300 text-gray-500 cursor-not-allowed" 
                : "bg-white border-gray-300 text-black"
            }`}
          >
            {selectedDependencies.length === 0 
              ? "No dependencies" 
              : `${selectedDependencies.length} task(s) selected`}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56 bg-white text-black">
          <DropdownMenuLabel>Select task dependencies</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {availableTasks.length === 0 ? (
            <div className="px-2 py-1.5 text-sm text-gray-500">No available tasks</div>
          ) : (
            availableTasks.map(task => (
              <DropdownMenuCheckboxItem
                key={task.id}
                checked={selectedDependencies.includes(task.id)}
                onCheckedChange={() => handleDependencyChange(task.id)}
                className="text-black"
              >
                {task.name}
              </DropdownMenuCheckboxItem>
            ))
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
